<div>
  <document-doc-supplier-delivery-address
    class="d-block"
    [docForm]="docForm"
    [addresses$]="deliveryAddresses$"
    [docRoleInput]="docRoleInput"
    [showSearch]="showSearch"
  ></document-doc-supplier-delivery-address>
</div>
